<template>
  <!-- 设计数据 -->
  <div>
    <HeadControl
     ref="headControl" :titleName="'设计数据'"
      @changeVal="changeVal"
      @changDate="changDate"
      @changePicker="changePicker"
    />
    <div class="wrap">
      <div class="top">
        <span class="partTitle_box">
          <span class="partTitle">进度数据</span>
        </span>
        <div class="chart_box">
          <div class="chart_left">
            <div class="left-t" v-for="(item, index) in reportList" :key="index">
              <div class="icon">
                <img :src="item.itemIcon" />
              </div>
              <div class="desc">
                <div class="a-title">{{item.itemName}}</div>
                <div class="amount" v-if="item.itemName.includes('金额')">{{aFormat(item.amount)}}<span>元</span></div>
                <div class="amount" v-if="item.itemName.includes('数量')">{{item.count}}<span>个</span></div>
              </div>
            </div>
          </div>
          <div class="progressData" ref="progressData"></div>
          <div class="projectArea">
            <div class="p_title">项目地区</div>
            <div
              class="areaWrap"
              v-for="(item, index) in designRegionData"
              :key="index"
            >
              <div class="item">
                <div class="left">
                  <div class="location">{{ item.itemName }}</div>
                  <div class="number">
                    <span class="num">{{ item.count }}</span
                    >个
                  </div>
                </div>
                <div class="right">
                  <img :src="item.itemIcon" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="partTitle_box">
          <div class="partTitle">异常数据</div>
        </div>
        <div class="chart_box">
          <div class="pieChart">
            <div class="abnormalTotal">
              <div class="total">异常总数</div>
              <div class="number"><span class="num">{{abnormalTotal}}</span>个</div>
            </div>
            <div class="abnormalData" ref="abnormalData"></div>
          </div>
          <div class="abnormalType" ref="abnormalType"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeadControl from "@/components/HeadControl";
import * as Urls from "@/helper/Urls";
import {amountFormat} from '@/helper/VueHelper';
export default {
  components: {
    HeadControl,
  },
  data() {
    return {
      orgCode: "", //组织架构
      dataRange: [], //时间
      progressData: {}, //进度比例数据
      progressMaxNum: 0,
      progressMaxPercent: 0,
      designRegionData: [], //项目地区数据
      abnormalData: [], //异常数据(饼图)
      percent1: 0,
      abnormalTotal: 0,   //异常总数
      abnormalTypeData: {},
      abnormalMaxNum: 0,
      abnormalMaxPercent: 0,
      screenWidth: document.body.clientWidth,
      isH5: false,
      reportList: []
    };
  },
  methods: {
    init() {
      this.$refs.headControl.getDatas('month');
      this.$refs.headControl.getSysOrg();
    },
    // 获取组织架构ID
    changeVal(val) {
      this.orgCode = val;
      this.getProgressData();
      this.getDesignRegionData();
      this.getAbnormalData();
      this.getAbnormalTypeData();
      this.getBuyingIsMoneyAndNumber();
    },
    // 日期改变
    changDate(val) {
      this.dataRange = val;
      this.getProgressData();
      this.getDesignRegionData();
      this.getAbnormalData();
      this.getAbnormalTypeData();
      this.getBuyingIsMoneyAndNumber();
    },
    // 时间
    changePicker(val) {
      this.dataRange = val;
      this.getProgressData();
      this.getDesignRegionData();
      this.getAbnormalData();
      this.getAbnormalTypeData();
      this.getBuyingIsMoneyAndNumber();
    },
    aFormat(amount) {
      return amountFormat(amount);
    },
    getBuyingIsMoneyAndNumber(){
      let url = Urls.getEchartsProjectOrDesignOrBuyingIsMoneyAndNumber
      let params = {
         orgCode: this.orgCode || "",
         startTime: this.dataRange.length ? this.dataRange[0] : "",
         endTime: this.dataRange.length ? this.dataRange[1] : "",        
         contractCat: 'DESIGN'
      }
       this.$root.doPost(url,params,(server_data)=>{
            // 用户没有登录
           if( !this.$root.isUserLogin(server_data)){
           return;
         }

         // 应用错误
         if(server_data.error){
             this.$root.showGlobalError(server_data.error);
             return;
         }    
          this.reportList = server_data.data.reportList
        })      
    },
    // 进度比例柱状折线图
    initProgressChart() {
      this.progressDataChart = this.$echarts.init(this.$refs.progressData);
      const option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "进度比例",
          padding: this.isH5 ? [24, 0, 0, 20]:[24, 0, 0, 30],
          textStyle:{
            fontWeight: 'normal'
          }
        },
        grid: {
          left:  this.isH5? 24:33,
          top: 97,
          right:  this.isH5? 24:33,
          bottom: 29,
          containLabel: true,
        },
        opacity: 0.1,
        tooltip: {
          trigger: "axis",
          formatter: (params)=>{
            let message = ''
            params.reverse().forEach(function(item, index){
              if(item.seriesIndex == 1) {
                message += item.axisValue + ': ' + item.data + '个' + '<br>'
              }else{
                message += '占比: ' + item.data + '%'
              } 
            })
            return `<div style="padding: 5px 8px; font-size: 12px">${message}</div>`
          }
        },
        legend: {
          data: this.progressData.legend,
          itemWidth: 40,
          itemHeight: 8,
          top: '20',
          left: this.isH5 ?'120' : '180',   
          itemGap: 20,// 每个icon之间的距离（单位px）
          textStyle: {
              fontSize: '13',            
              height: 10,
                rich: {
                a: {
                  verticalAlign: 'middle',
                },
              }
          },  
        },
        xAxis: [
          {
            type: "category",
            data: this.progressData.xAxis.data,
            // 分隔线
            splitLine: {
              show: this.progressData.series[1].data.reduce((a,b)=>a+b)===0 ? false : true,
              lineStyle: {
                color: "#ddd",
              },
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: this.progressData.series[1].data.reduce((a,b)=>a+b)===0 ? true : false,
              lineStyle:{
                color: '#ddd'
              }
            },
            axisLabel:{
              color:'#666',
              margin: 20
            },
            axisPointer: {
              type: 'none'
            },
          },
        ],
        yAxis: [
          {
            show: this.progressData.series[1].data.reduce((a,b)=>a+b)===0 ? false : true,
            // 数据显示
            type: "value",
            name: "百分比",
            min: 0,
            max: this.progressMaxPercent,
            splitNumber: 5,
            interval: this.progressMaxPercent / 5,
            axisLabel: {
              formatter: "{value}%",
              margin: 20,
            },
            // 坐标轴名称的文字样式
            nameTextStyle: {
              padding: [0, 65, 0, 0],
            },
            axisTick: {
              length: 16,
              lineStyle: {
                color: "#ddd",
              },
            },
            axisLine: {
              show: false,
            },
            splitLine: {
              show: false,
            }
          },
          {
            show: this.progressData.series[1].data.reduce((a,b)=>a+b)===0 ? false : true,
            type: "value",
            name: "数量（个）",
            min: 0,
            max: this.progressMaxNum,
            splitNumber: 5,
            interval: this.progressMaxNum / 5,
            // 坐标轴名称的文字样式
            nameTextStyle: {
              padding: [0, 0, 0, 40],
            },
            axisTick: {
              length: 16,
              lineStyle: {
                color: "#ddd",
              },
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              margin: 20,
              formatter: function (value) {
                return parseInt(value);
              },
            },
            splitLine:{
              lineStyle: {
                color: "#ddd",
              },
            }
          },
        ],
        series: [
          {
            // name: "百分比",
            name: this.progressData.series[0].name,
            type: "bar",
            barWidth: '60%',
            data: this.progressData.series[0].data,
            itemStyle: {
              normal: {
                color: 'rgba(87, 185, 255, 0.35)',
                borderColor:this.progressData.series[1].data.reduce((a,b)=>a+b)===0 ? 'rgba(87, 185, 255, 0)':'rgba(87, 185, 255, 1)',
              },
            },
            yAxisIndex: 0,
          },
          {
            // name: "个数",
            name: this.progressData.series[1].name,
            type: "line",
            symbol: "rect",
            symbolSize: 9,
            hoverAnimation: false,
            data: this.progressData.series[1].data,
            itemStyle: {
              normal: {
                color: "#61d9ac",
                opacity: this.progressData.series[1].data.reduce((a,b)=>a+b)===0 ? 0 : 1,
              },
              emphasis: {          //突出效果配置(鼠标置于拐点上时)
                borderWidth: 3,
                borderColor: '#61d9ac',
                color: '#61d9ac',
              },
            },
            lineStyle: {
              normal: {
                opacity: this.progressData.series[1].data.reduce((a,b)=>a+b)===0 ? 0 : 1,
              }
            },
            yAxisIndex: 1,
          },
        ],
      };
      this.progressDataChart.setOption(option);
      window.addEventListener("resize", () => {
        this.isH5 ? this.progressDataChart.resize({width: this.screenWidth - 24}) : this.progressDataChart.resize();
      });
      this.isH5 ? this.progressDataChart.resize({width: this.screenWidth - 24}) : this.progressDataChart.resize();
    },
    // 异常数据饼状图
    initAbnormalDataChart() {
      this.abnormalDataChart = this.$echarts.init(this.$refs.abnormalData);
      const option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        color:["#57B9FF", "#FFB96E", "#E5E5E5"],
        series: [
          {
            name: this.abnormalData[0].name,
            type: "pie",
            startAngle: 180,
            center: this.isH5 ? ["25%", "50%"]:["30%", "50%"],
            radius: this.isH5 ? ["35%", "39%"] : this.radius, // 决定圆环的位置及粗细
            avoidLabelOverlap: false, // 是否启用防止标签重叠策略
            hoverAnimation: false, // 关闭放大动画
            selectedOffset: 0, // 选中块的偏移量
            label: {
              normal: {
                show: false,
                position: "center",
                //   formatter: "{a}\n{c}个\n{d}%",
                formatter: (params) => {
                  this.percent1 = params.percent.toFixed(0)
                  const str = `{a|${params.name}}\n{b|${params.value}}{a|个}\n{c|${this.percent1}%}`;
                  return str;
                },
                textStyle: {
                  rich: {
                    a: {
                      color: "#666",
                      fontSize: this.isH5 ? 12:14,
                      lineHeight: this.isH5 ? 20 :25,
                    },
                    b: {
                      color: "#333",
                      fontSize: this.isH5 ? 18: 26,
                      fontWeight: 500,
                      lineHeight: this.isH5 ? 20 : 30,
                    },
                    c: {
                      fontSize: this.isH5 ? 12 :14,
                      lineHeight: this.isH5 ? 15:20,
                    },
                  },
                },
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                // 进度条数据data
                value: this.abnormalData[0].value,
                name: this.abnormalData[0].name,
                selected: true, //默认选中第一块
                label: {
                  normal: {
                    show: true, //默认显示第一块
                    fontSize: "20",
                    color: "#57B9FF",
                  },
                },
              },
              {
                // 灰色块data
                value: this.abnormalData[0].value===0?10:this.abnormalData[1].value,
                name: this.abnormalData[0].name,
                itemStyle: {
                  // 设置相同的默认颜色和高亮颜色
                  normal: { color: "#e5e5e5" },
                  emphasis: { color: "#e5e5e5" },
                },
              },
            ],
          },
          {
            name: this.abnormalData[1].name,
            type: "pie",
            startAngle: this.startAngle,
            // clockWise: false,
            center: ["70%", "50%"],
            radius: this.isH5 ? ["35%", "39%"] : this.radius, // 决定圆环的位置及粗细
            avoidLabelOverlap: false, // 是否启用防止标签重叠策略
            hoverAnimation: false, // 关闭放大动画
            selectedOffset: 0, // 选中块的偏移量
            label: {
              normal: {
                show: false,
                position: "center",
                formatter: (params) => {
                  const str = `{a|${params.name}}\n{b|${params.value}}{a|个}\n{c|${this.abnormalTotal===0 ? 0:(100 - this.percent1)}%}`;
                  return str;
                },
                textStyle: {
                  rich: {
                    a: {
                      color: "#666",
                      fontSize: this.isH5 ? 12:14,
                      lineHeight: this.isH5 ? 20 :25,
                    },
                    b: {
                      color: "#333",
                      fontSize: this.isH5 ? 18: 26,
                      fontWeight: 500,
                      lineHeight: this.isH5 ? 20 : 30,
                    },
                    c: {
                      fontSize: this.isH5 ? 12 :14,
                      lineHeight: this.isH5 ? 15:20,
                    },
                  },
                },
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                // 进度条数据data
                value: this.abnormalData[1].value,
                name: this.abnormalData[1].name,
                selected: true, //默认选中第一块
                label: {
                  normal: {
                    show: true, //默认显示第一块
                    fontSize: "20",
                    color: "#FFB96E",
                  },
                },
              },
              {
                // 灰色块data
                value: this.abnormalData[1].value===0?10:this.abnormalData[0].value,
                name: this.abnormalData[1].name,
                itemStyle: {
                  // 设置相同的默认颜色和高亮颜色
                  normal: { color: "#e5e5e5" },
                  emphasis: { color: "#e5e5e5" },
                },
              },
            ],
          },
        ],
      };
      this.abnormalDataChart.setOption(option);
      window.addEventListener("resize", () => {
        this.isH5 ? this.abnormalDataChart.resize({width: (this.screenWidth - 24) * 0.8}) : this.abnormalDataChart.resize();
      });
      this.isH5 ? this.abnormalDataChart.resize({width: (this.screenWidth - 24) * 0.8}) : this.abnormalDataChart.resize();
    },
    // 异常类型柱状折线图
    initAbnormalTypeChart() {
      this.abnormalTypeChart = this.$echarts.init(this.$refs.abnormalType);
      const option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "异常类型",
          padding: this.isH5 ? [24, 0, 0, 20] : [24, 0, 0, 30],
          textStyle:{
            fontWeight: 'normal'
          }
        },
        grid: {
          left:  this.isH5? 24:33,
          top: 97,
          right:  this.isH5? 24:33,
          bottom: 17,
          containLabel: true
        },
        opacity: 0.1,
        tooltip: {
          trigger: "axis",
          formatter: (params)=>{
            let message = ''
            params.reverse().forEach(function(item, index){
              if(item.seriesIndex == 1) {
                message += item.axisValue + ': ' + item.data + '个' + '<br>'
              }else{
                message += '占比: ' + item.data + '%'
              } 
            })
            return `<div style="padding: 5px 8px; font-size: 12px">${message}</div>`
          }
        },
        legend: {
          data: this.abnormalTypeData.legend,
          itemWidth: 40,
          itemHeight: 8,
          top: '20',
          left: this.isH5 ? '120' : '180',   
          itemGap: 20,// 每个icon之间的距离（单位px）
          textStyle: {
              fontSize: '13',            
              height: 10,
                rich: {
                a: {
                  verticalAlign: 'middle',
                },
              }
          },  
        },
        xAxis: [
          {
            type: "category",
            data: this.abnormalTypeData.xAxis.data,
            axisPointer: {
              type: 'none',
            },
            // 分隔线
            splitLine: {
              show: this.abnormalTypeData.series[1].data.reduce((a,b)=>a+b)===0 ? false:true,
              lineStyle: {
                color: "#ddd",
              },
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: this.abnormalTypeData.series[1].data.reduce((a,b)=>a+b)===0 ? true:false,
              lineStyle:{
                color: '#ddd'
              }
            },
            axisLabel:{
              color:'#666',
              margin: 12
            }
          },
        ],
        yAxis: [
          {
            show: this.abnormalTypeData.series[1].data.reduce((a,b)=>a+b)===0 ? false:true,
            // 数据显示
            type: "value",
            name: "百分比",
            min: 0,
            max: this.abnormalMaxPercent,
            splitNumber: 5,
            interval: this.abnormalMaxPercent / 5,
            axisLabel: {
              formatter: "{value}%",
              margin: 20,
            },
            // 坐标轴名称的文字样式
            nameTextStyle: {
              padding: [0, 65, 0, 0],
            },
            axisTick: {
              length: 16,
              lineStyle: {
                color: "#ddd",
              },
            },
            axisLine: {
              show: false,
            },
            splitLine: {
              show: false
            }
          },
          {
            show: this.abnormalTypeData.series[1].data.reduce((a,b)=>a+b)===0 ? false:true,
            type: "value",
            name: "数量（个）",
            min: 0,
            max: this.abnormalMaxNum,
            splitNumber: 5,
            interval: this.abnormalMaxNum / 5,
            // 坐标轴名称的文字样式
            nameTextStyle: {
              padding: [0, 0, 0, 40],
            },
            axisTick: {
              length: 16,
              lineStyle: {
                color: "#ddd",
              },
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              margin: 20,
              formatter: function (value) {
                return parseInt(value);
              },
            },
            splitLine:{
              lineStyle: {
                color: "#ddd",
              },
            }
          },
        ],
        series: [
          {
            // name: "百分比",
            name: this.abnormalTypeData.series[0].name,
            type: "bar",
            barWidth: '60%',
            data: this.abnormalTypeData.series[0].data,
            itemStyle: {
              normal: {
                color: 'rgba(87, 185, 255, 0.35)',
                borderColor:this.abnormalTypeData.series[1].data.reduce((a,b)=>a+b)===0 ? 'rgba(87, 185, 255, 0)':'rgba(87, 185, 255, 1)',
              },
            },
            yAxisIndex: 0,
          },
          {
            // name: "个数",
            name: this.abnormalTypeData.series[1].name,
            type: "line",
            symbol: "rect",
            symbolSize: 9,
            hoverAnimation: false,
            data: this.abnormalTypeData.series[1].data,
            itemStyle: {
              normal: {
                color: "#61d9ac",
                opacity: this.abnormalTypeData.series[1].data.reduce((a,b)=>a+b)===0 ? 0:1,
              },
              emphasis: {          //突出效果配置(鼠标置于拐点上时)
                borderWidth: 3,
                borderColor: '#61d9ac',
                color: '#61d9ac',
              },
            },
            lineStyle: {
              normal: {
                opacity: this.abnormalTypeData.series[1].data.reduce((a,b)=>a+b)===0 ? 0:1,
              }
            },
            yAxisIndex: 1,
          },
        ],
      };
      this.abnormalTypeChart.setOption(option);
      window.addEventListener("resize", () => {
        this.isH5 ? this.abnormalTypeChart.resize({width: this.screenWidth - 24}) : this.abnormalTypeChart.resize();
      });
      this.isH5 ? this.abnormalTypeChart.resize({width: this.screenWidth - 24}) : this.abnormalTypeChart.resize();
    },
    // 获取进度比例数据
    getProgressData() {
      let url = Urls.getEchartsDesignTypeReportItemData;
      let params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
      };
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return;
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error);
          return;
        }
        this.progressData = server_data.data;
      });
    },
    // 获取项目地区数据
    getDesignRegionData() {
      let url = Urls.getEchartsDesignReportDataByRegion;
      let params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: "PROJECT_REGION",
      };
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return;
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error);
          return;
        }
        this.designRegionData = server_data.data.reportList;
      });
    },
    // 获取异常数据饼图数据
    getAbnormalData() {
      let url = Urls.getEchartsDesignReportItemData;
      let params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
      };
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return;
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error);
          return;
        }
        this.abnormalData = server_data.data;
        this.abnormalTotal = 0
        this.abnormalData.forEach((item) =>{
          this.abnormalTotal += item.value
        })
      });
    },
    // 获取异常类型数据
    getAbnormalTypeData() {
      let url = Urls.getEchartsDesignAbnormalTypeReportItemData;
      let params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
      };
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return;
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error);
          return;
        }
        this.abnormalTypeData = server_data.data;
      });
    },
  },
  computed:{
    startAngle(){
      let total = this.abnormalData[0].value + this.abnormalData[1].value;
      if (total === 0) {
        return 180;
      } else {
        let res = (this.abnormalData[0].value / total) * 360;
        if (res > 180) {
          return 360 + (180 - res);
        } else {
          return 180 - res;
        }
      }
    },
    radius() {
      return this.screenWidth < 1366 ? ["45%", "49%"] : ["50%", "54%"]
    }
  },
  watch: {
    progressData(newVal) {
      if (newVal) {
        this.progressMaxNum = Math.ceil(Math.max(...newVal.series[1].data) / 10) * 10;
        this.progressMaxPercent = Math.ceil(Math.max(...newVal.series[0].data) / 10) * 10;
        this.initProgressChart();
      }
    },
    abnormalData(newVal) {
      if (newVal) {
        this.initAbnormalDataChart();
      }
    },
    abnormalTypeData(newVal) {
      if (newVal) {
        this.abnormalMaxNum = Math.ceil(Math.max(...newVal.series[1].data) / 10) * 10;
        this.abnormalMaxPercent = Math.ceil(Math.max(...newVal.series[0].data) / 10) * 10;
        this.initAbnormalTypeChart();
      }
    },
    screenWidth(newVal) {
      this.initAbnormalDataChart()
    }
  },
  mounted() {
    if(this.$route.query.identification) {
      this.isH5 = true
    }
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth; //实时宽度
        this.screenWidth = window.screenWidth;
      })();
    }; 
  }
};
</script>

<style lang="scss" scoped>
.wrap {
  margin-top: 0.29rem;
  .top {
    margin-bottom: 32px;
    .chart_box {
      display: flex;
      .chart_left {
        width: 30%;
        box-sizing: border-box;
        padding: 0 0.3rem;
        margin-right: 0.24rem;
        background: #ffffff;
        box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
        border-radius: 0.1rem;
        .left-t {
          display: flex;
          // justify-content: center;
          align-items: center;
          padding: 0.65rem 0 0.65rem 0.36rem;
          border-bottom: 1px solid #eee;
          .icon {
            width: 0.75rem;
            height: 0.75rem;
            margin-right: 0.35rem;
          }
          .desc {
            .a-title {
              font-size: 0.14rem;
              color: #666666;
              margin-bottom: 0.05rem;
            }
            .amount {
              font-size: 0.26rem;
              color: #333;
              span {
                font-size: 0.14rem;
              }
            }
          }
          &:last-child {
            border-bottom: none;
          }
        }
      }
      .progressData {
        box-sizing: border-box;
        width: 40%;
        height: 410px;
        margin-right: 24px;
        background-color: #fff;
        -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border-radius: 0.1rem;
      }
      .projectArea {
        width: 30%;
        height: 410px;
        background-color: #fff;
        -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border-radius: 0.1rem;
        .p_title {
          border-bottom: none;
          font-size: 18px;
          // font-weight: bolder;
          color: #333;
          padding: 24px 0 0 30px;
        }
        .areaWrap {
          width: 90%;
          height: 29.5%;
          box-sizing: border-box;
          margin: 0 auto;
          border-bottom: 1px solid #eee;
          .item {
            height: 100%;
            display: flex;
            padding: 0 5%;
            justify-content: space-between;
            align-items: center;
            .location {
              font-size: 14px;
              color: #666;
              margin-bottom: 17px;
            }
            .number {
              color: #333;
            }
            .num {
              font-size: 20px;
              color: #333;
              font-weight: bold;
            }
          }
          .item:last-of-type {
            border-right: none;
          }
        }
        .areaWrap:last-of-type {
          border: none;
        }
      }
    }
  }
  .bottom {
    // height: 350px;
    .chart_box {
      display: flex;
      .pieChart,
      .abnormalType {
        width: 50%;
        height: 310px;
        box-sizing: border-box;
        background-color: #fff;
        -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border-radius: 0.1rem;
      }
      .pieChart {
        margin-right: 24px;
        display: flex;
        align-items: center;
        .abnormalTotal {
          width: 22%;
          height: 100px;
          border-right: 1px solid #ddd;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        .abnormalData {
          width: 78%;
          height: 100%;
        }
      }
    }
  }
  .partTitle_box {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .partTitle {
      font-size: 18px;
      font-weight: 800;
      color: #333;
    }
  }
  .partTitle_box::before {
    content: "";
    display: block;
    width: 4px;
    height: 18px;
    background-color: #297afe;
    margin-right: 11px;
  }
  .total {
    margin-bottom: 12px;
    font-size: 14px;
    color: #666;
  }
  .number {
    .num {
      font-size: 26px;
      color: #333;
    }
  }
}
@media screen and (max-width: 768px){
  .wrap{
    width: calc(100% - 0.24rem);
    margin: 0 auto;
    margin-top: -0.05rem;
    .top{
      margin-bottom: 0.12rem;
      .chart_box{
        flex-direction: column;
        .chart_left {
          width: 100% !important;
          margin-bottom: 0.12rem;
          .left-t{
            padding: 0.2rem 0 0.2rem 0.2rem !important;
          }
        }
        .progressData, .projectArea{
          .p_title{
            padding-left: 20px;
          }
          width: 100%;
        }
        .progressData{
          background-color: #fff !important;
          margin-bottom: 0.12rem;
        }
      }
    }
    .bottom{
      .chart_box{
        flex-direction: column;
        .pieChart, .abnormalType{
          width: 100%;
        }
        .pieChart{
          margin-bottom: 0.12rem;
        }
        .abnormalType {
          background-color: #fff !important;
        }
      }
    }
    .partTitle_box{
      margin-bottom: 0.12rem;
    }
  }
}
@media screen and (max-width: 1550px) {
  .wrap .top .chart_box .chart_left .left-t{
    padding-left: 0.12rem;
    .icon{
      margin-right: 0.24rem;
    }
  }
  .wrap .top .chart_box .chart_left .left-t .desc .amount{
    font-size: 0.16rem;
  }
}
</style>


// WEBPACK FOOTER //
// designData.vue?7cd7ff8e